import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, ArrowRight, Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';

const HERO_IMG = "http://roseofjericho-cd.org/wp-content/uploads/2026/05/gallery_page_9_popup.jpg";
const HERO_IMG_2 = "https://images.unsplash.com/photo-1786648242546-cdd1a0c117cd?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

export default function Hero() {
  return (
    <section className="relative flex min-h-[42rem] items-center justify-center overflow-hidden sm:min-h-screen">
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={HERO_IMG_2} alt="Community gathering" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a1220]/90 via-[#241522]/60 to-[#0f1d1a]/85" />
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-5xl px-4 pt-20 text-center sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <p className="mb-6 text-sm font-semibold uppercase tracking-[0.28em] text-[#f1cf64] sm:text-base">
            501(c)(3) Non-Profit Organization
          </p>
          <h1 className="mb-6 font-heading text-5xl font-bold leading-[1.05] text-white sm:text-6xl md:text-7xl">
            Building Community.
            <br />
            <span className="italic text-yellow-300">Restoring Hope.</span>
          </h1>
          <p className="mx-auto mb-10 max-w-2xl text-lg font-light leading-relaxed text-white/80 sm:text-xl">
            Rose of Jericho Community Development Center is dedicated to
            transformation and restoration - empowering communities through
            development, education, and sustainable growth.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Button
            onClick={() => document.querySelector('#mission')?.scrollIntoView({ behavior: 'smooth' })}
            className="rounded-full bg-primary px-8 py-6 text-base font-semibold text-white shadow-lg shadow-primary/30 transition hover:-translate-y-0.5 hover:bg-primary/90"
          >
            Explore Our Mission
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <Button
            onClick={() => document.querySelector('#donate')?.scrollIntoView({ behavior: 'smooth' })}
            variant="outline"
            className="rounded-full border-white/40 px-8 py-6 text-base font-semibold text-white transition hover:-translate-y-0.5 hover:bg-white/10"
          >
            <Heart className="w-4 h-4 mr-2" />
            Support Our Cause
          </Button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 1 }}
          className="mt-16"
        >
          <button
            onClick={() => document.querySelector('#mission')?.scrollIntoView({ behavior: 'smooth' })}
            className="text-white/60 hover:text-white transition-colors"
          >
            <ArrowDown className="w-6 h-6 animate-bounce" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}